import React from "react";
import { StateMessaging } from "@middleware/types";
import { globalStatusInitialState } from "@middleware/init";

export const GlobalMessagingContext = React.createContext<StateMessaging>(
  globalStatusInitialState
);
